import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6bf22c0c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf22c0c')) {
      api.createRecord('6bf22c0c', component.options)
    } else {
      api.reload('6bf22c0c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6bf22c0c&", function () {
      api.rerender('6bf22c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O4573992EJmS/JS/pricehelp.vue"
export default component.exports